export default "__VITE_ASSET__CeNl$bX3__"